import Vue from 'vue'
import VRLoadMore  from './loadmore'

export default VRLoadMore




// WEBPACK FOOTER //
// ./src/components/loadmore/index.js